import { Button, Grid, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useRequestResetMutation } from "../../api/api-hooks";
import logo from "./logoCompressed.webp";

const ForgotPassword = () => {
  const [email, setEmail] = useState<string>("");
  const [feedback, setFeedback] = useState<string>(
    "Please enter your email address to reset your password."
  );
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [resetPassword] = useRequestResetMutation();
  const { push } = useHistory();
  const handleSubmit = () => {
    resetPassword({ createPasswordResetDto: { email } });
    setSubmitted(true);
    setFeedback(
      "We received your request. If your email address matches that of one of our users, we will send you a password reset email."
    );
  };
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <img src={logo} alt="LP Technologies Logo" />
      </Grid>
      <Grid item>
        <Typography>{feedback}</Typography>
      </Grid>
      <Grid item>
        <TextField
          style={{ width: "400px" }}
          name="email"
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
          }}
          label="Email Address"
          variant="outlined"
        ></TextField>
      </Grid>
      {!submitted && (
        <Grid item>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Submit
          </Button>
        </Grid>
      )}
      <Grid item>
        <Button
          onClick={() => {
            push("/login");
          }}
          variant="outlined"
          color="primary"
        >
          To Login Page
        </Button>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
